import { render, staticRenderFns } from "./MXRecordForm.vue?vue&type=template&id=4b79fadf&"
import script from "./MXRecordForm.vue?vue&type=script&lang=js&"
export * from "./MXRecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b79fadf')) {
      api.createRecord('4b79fadf', component.options)
    } else {
      api.reload('4b79fadf', component.options)
    }
    module.hot.accept("./MXRecordForm.vue?vue&type=template&id=4b79fadf&", function () {
      api.rerender('4b79fadf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ZoneEditor/Records/MXRecordForm.vue"
export default component.exports